<app-filter-operator
  [operators]="appFilterOperators()"
  [notOperators]="appFilterNotOperators()"
  [operator]="filterCommand()"
  (operatorChange)="operatorChanged($event)"
></app-filter-operator>
<div class="group relative border border-solid border-gray-200 rounded mb-1">
  <input
    class="w-full py-1 px-2 rounded focus:outline-1 focus:outline-primary-200"
    [formControl]="filterControl"
  />
  <div
    class="hidden text-primary/40 hover:text-primary absolute right-1 top-1"
    [class.group-hover:block]="!!filterControl.value"
    (click)="empty()"
  >
    <mat-icon inline class="inline-flex align-middle mr-1">backspace</mat-icon>
  </div>
</div>
